import { render, staticRenderFns } from "./testList.vue?vue&type=template&id=303b55e7&scoped=true"
import script from "./testList.vue?vue&type=script&lang=js"
export * from "./testList.vue?vue&type=script&lang=js"
import style0 from "./testList.vue?vue&type=style&index=0&id=303b55e7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303b55e7",
  null
  
)

export default component.exports